import React from 'react';
import PropTypes from 'prop-types';

export const RocketLaunch = ({ width = 64, height = 64 }) => (
  <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.712 41.4242C33.6344 40.6569 33.3821 39.9176 32.9744 39.2631C32.5667 38.6085 32.0144 38.0561 31.36 37.6482C30.56 37.2242 29.688 37.3122 28.904 37.0322C27.64 36.5762 27.92 36.6802 27.096 35.3282C26.5003 34.3084 25.6838 33.4349 24.7065 32.7718C23.7291 32.1087 22.6158 31.6728 21.448 31.4961C21.1277 31.2447 20.7559 31.067 20.359 30.9757C19.9621 30.8844 19.55 30.8818 19.152 30.9681C15.416 31.6801 7.41602 33.3681 7.41602 38.4081C7.41611 38.8933 7.5441 39.3699 7.78707 39.7898C8.03005 40.2098 8.37944 40.5583 8.80002 40.8002C9.89971 41.3062 11.1182 41.4973 12.32 41.3521C12.176 41.7201 12.04 42.0882 11.92 42.4642C11.424 44.0002 10.84 45.8722 11.416 47.4562C12.216 49.7202 13.608 49.9202 15.112 49.5842C14.496 51.5922 14.312 53.6402 15.912 55.2562C18.112 57.4802 21.144 55.9442 23.68 54.3682C23.9871 54.662 24.3562 54.8835 24.76 55.0162C25.5663 55.2465 26.4217 55.2416 27.2253 55.002C28.0289 54.7625 28.7474 54.2983 29.296 53.6642C32.104 50.8322 34.352 45.4642 33.712 41.4242Z"
      fill="#F1F1F1"
    />
    <path
      d="M27.7442 22.9118C33.3442 16.3198 42.5682 12.0478 50.5682 12.1838C50.7772 12.1936 50.9751 12.281 51.1231 12.4289C51.271 12.5769 51.3585 12.7748 51.3682 12.9838C51.5522 20.9838 47.2322 30.1758 40.6162 35.8238L38.5122 37.5278L31.0322 43.5678C30.8806 43.7098 30.6798 43.7872 30.4722 43.7838C30.3617 43.7856 30.2521 43.7645 30.1502 43.7218C30.0483 43.6791 29.9564 43.6158 29.8802 43.5358L20.1202 33.5358C19.9734 33.38 19.8916 33.1739 19.8916 32.9598C19.8916 32.7457 19.9734 32.5397 20.1202 32.3838L25.2322 26.0318"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M38.9922 20.3199C38.0102 20.3127 37.0561 20.6459 36.2921 21.2628C35.5281 21.8797 35.0015 22.7423 34.8017 23.7037C34.602 24.6652 34.7415 25.6661 35.1965 26.5363C35.6516 27.4065 36.394 28.0921 37.2976 28.4766C38.2011 28.8611 39.21 28.9207 40.1526 28.6453C41.0951 28.3698 41.9131 27.7763 42.4674 26.9657C43.0217 26.1552 43.2781 25.1776 43.1929 24.1993C43.1077 23.221 42.6862 22.3025 42.0002 21.5999C41.2008 20.8053 40.1193 20.3595 38.9922 20.3599V20.3199Z"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M34.0079 41.3441L22.2319 29.6001" stroke="#00005A" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M18.8482 36.9678C16.0069 38.9905 12.6752 40.2143 9.2002 40.5118L9.3362 42.1118C13.0835 41.7888 16.6752 40.4654 19.7362 38.2798L18.8482 36.9678ZM24.8562 43.2718C22.1916 46.4486 20.1775 50.1181 18.9282 54.0718L20.4642 54.5358C21.6672 50.809 23.5676 47.3449 26.0642 44.3278L24.8562 43.2718ZM21.6562 39.8798L14.4562 47.3278L15.6082 48.4398L22.8082 40.9918L21.6562 39.8798Z"
      fill="url(#paint0_linear_55581_115973)"
    />
    <path d="M45.7681 14.2798L49.3121 17.8158" stroke="#00005A" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M42.2802 37.0078V40.7758L37.4642 45.5918L34.7842 42.9198"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M26.544 21.3198H22.776L17.96 26.1358L20.64 28.8158"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_55581_115973"
        x1="17.3122"
        y1="54.5358"
        x2="17.8402"
        y2="34.2078"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9F8A" />
        <stop offset="0.05" stopColor="#FF9793" />
        <stop offset="0.11" stopColor="#FF8AA4" />
        <stop offset="0.15" stopColor="#FF80B1" />
        <stop offset="0.24" stopColor="#FF66D2" />
        <stop offset="0.33" stopColor="#FF44FF" />
        <stop offset="0.66" stopColor="#4900FF" />
        <stop offset="1" stopColor="#00005A" />
      </linearGradient>
    </defs>
  </svg>
);

RocketLaunch.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

RocketLaunch.defaultProps = {
  width: 64,
  height: 64,
};
